import { useSentryQuery } from '../utils/sentryQueryWrapper';
import { fetchCapitalSummary } from '@/api/capitalService';
import { CapitalSummaryResponse, ErrorMessageResponse } from '@/types';

// Boxy Capital summary — 60s poll while mounted (same cadence and reason as
// advance-cod: coverage moves as COD lands, without navigation).
export const useFetchCapitalSummary = (enabled: boolean = true) =>
  useSentryQuery<CapitalSummaryResponse, ErrorMessageResponse>(
    ['capital-summary'],
    () => fetchCapitalSummary(),
    { enabled, staleTime: 60000, refetchInterval: 60000 },
  );
